<template>

      <v-card class="mx-auto"  max-width="1000" min-width="300">
        <v-toolbar :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1"
              >arrow_downward</v-icon
            >
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>

        </v-toolbar>
        
  <v-expand-transition>
        <div v-if="Hide">
          <div v-if="Content.length!=0">
  <v-data-table
    :headers="headers"
    :items="Content"
    item-key="name"
    sort-by="name"
    group-by="currentStep"
      :pagination.sync="pagination"
    class="elevation-1"
    show-group-by
  >

  <template v-slot:items="props">
   <td class="text-xs-right">{{ props.item.name }}</td>
                <td class="text-xs-right">{{ props.item.steps[0].comment }}</td>
                <td  class="text-xs-right" v-if="typ != 'me'">
                                    <v-select
                  :items="membernameandId"
                  
                 item-text="[0]"
                 item-value="[1]"
                  label="Möjlig ägare"
                  hint="Vem tror du är bäst lämpad som ägare av detta fall"
                  v-model="props.item.shouldOwn"
                  
                ></v-select>
                </td>
                <td class="text-xs-right">{{ locfun.getDate(props.item.steps[0].starttime)}}</td>
                <td class="text-xs-right">{{ locfun.getName(props.item.steps[0].ownerId,teachernameandId,membernameandId)}}</td>
                  <td class="text-xs-right">
                           
                <v-text-field  v-if="props.item.shouldOwn == id"
                  label="Kommentar"
                  hint="Lägg till en kommentar"
                  v-model="props.item.Comment"
                  
                ></v-text-field>
              </td>
                <td class="text-xs-right" v-if="props.item.shouldOwn == id">

    <v-btn
      class="mx-2"
      fab
      dark
      small 
      @click="Accept(props.item)"
      color="green ligthen-1"
    >
      <v-icon dark>
        done
      </v-icon>
    </v-btn>
    <v-btn  v-if="typ == 'me'"
      class="mx-2"
      fab
      dark
      small
       @click="Deny(props.item)"
      color="red ligthen-1"
    >
      <v-icon dark>
        clear
      </v-icon>
    </v-btn>
                </td>
                   <td class="text-xs-right" v-else>

    <v-btn
      dark
      @click="Propose(props.item)"
      color="green ligthen-1"
    >
     Föreslå
    </v-btn>

                </td>


    </template>
</v-data-table> 
     <div class="text-xs-center pt-2">
      <v-btn color="light-blue darken-1" dark @click="toggleOrder">Ändra sorteringsordning</v-btn>
      <v-btn color="light-blue darken-1" dark @click="nextSort">Sortera på nästa kolumn</v-btn>
    </div>
          </div>
    <div v-else  :class="ToolColor+ ' lighten-2 text-center'">  
    <span class="tt" v-if="typ=='me'" color="white">Det finns inga nya förslag på dig som ägare över ärenden.</span>
    <span class="tt" v-else color="white">Det finns inga ärenden utan ägare.</span>
    </div>
        </div>
  </v-expand-transition>
      </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import fun from "./functions";
export default {
  props: {
    schoolId: String,
    id: String,
    Headline: String,
    // Content: Array,
    typ:String,
    ToolColor: String,
  },
  computed: {
    
    ...mapGetters("teachers", ["teachernameandId"]),
    ...mapGetters("ehtmembers", ["membernameandId"]),
    ...mapGetters('schools', ['school']),    
    ...mapGetters({ AllCases: 'cases/cases'}),
    ...mapGetters({ AllCasesFetched: 'cases/casesFetched'}),
    Content(){ //Använder de separata filterna och ger värden till variabeln Content
  if (this.typ=="me") {
  return this.AllCases.filter(C => C.shouldOwn == this.id)
  }
  else if (this.typ=="notme") {
    //console.log(this.AllCases)
    return this.AllCases.filter(C => C.steps.length == 1)
  }
  else
  return []
  },
  },
  created() {

     this.locfun= new fun();
      if (this.typ!="me") {//Om det är dennas så ska det stå förslag på ägare
        this.headers.splice(2,0,    { text: 'Förslag på ägare', value: 'förslag', align: 'right'},)
      }
      this.headers.forEach(header => {
        // header.class= this.school.primary+" lighten-3 white--text" ;
      });

         
 
},
  methods: {
   ...mapActions("cases", [
      ,'saveCase','initcasesEHT'
    ]),
 Loadin()
    {
      
     if (this.AllCasesFetched==false) 
      {
          //console.log("Fetched" + this.schoolId); 
      this.initcasesEHT(this.schoolId)
      }
      },
  

  

    toggleOrder () {
        this.pagination.descending = !this.pagination.descending
      },
      nextSort () {
        let index = this.headers.findIndex(h => h.value === this.pagination.sortBy)
        index = (index + 1) % this.headers.length
        index = index === 0 ? index + 1 : index
        this.pagination.sortBy = this.headers[index].value
      },

Accept(Case){
let step2={ownerId: this.id,step:"Mottagen", comment: Case.Comment}
delete Case.Comment;
Case.shouldOwn=""
this.saveCase([Case,step2])
},
Propose(Case){
this.saveCase([Case])
},
Deny(Case){
Case.shouldOwn=""
this.saveCase([Case])

 
  },
  
  },
  data() {
    return {
      pagination: {
          sortBy: 'steps[0].starttime'
        },
      headers:[
          { text: 'Namn', value: 'name', align: 'right'},
            { text: 'Kommentar från ärendegivare', value: 'comment', align: 'right'},
              { text: 'Ärendets starttid', value: 'starttime', align: 'right'},
                { text: 'Anmälare', value: 'anmälare', align: 'right'},
                  { text: 'Kommentar till EHT', value: 'Comment', align: 'right'},
                    { text: 'Val', value: 'val', align: 'right'},
      ],
      Hide: false,
      dialog: false,
      NewUser: {subscribersId:[this.id],schoolId: this.schoolId, steps: [{ownerId:this.id ,step: "Anmälan"}] },
      dialogcreate: false,
      Comment: ""
    };
  },
};
</script>

<style scoped>

</style>